import axios from '../config';
import { getToken, getMobileNumber } from '../../utils/session-utils';

export const postUserProvisionHighRisk = ({ locale }, onSuccess, onError) =>
  axios
    .post('/v1/twistle/userProvision', null, {
      headers: {
        Authorization: getToken(),
        mobileNumber: getMobileNumber(),
        locale
      }
    })
    .then(res => onSuccess(res.data))
    .catch(err =>
      onError(err.response.data ? err.response.data.message : err.message)
    );

export const postUserProvisionLowRisk = ({ locale }, onSuccess, onError) =>
  axios
    .post('/v1/twistle/userProvision/pathway2', null, {
      headers: {
        Authorization: getToken(),
        mobileNumber: getMobileNumber(),
        locale
      }
    })
    .then(res => onSuccess(res.data))
    .catch(err => {
      onError(err.response.data ? err.response.data.message : err.message);
    });
